/**
 * Returnerer Debug fra HN objektet
 * @returns true dersom window.HN.Debug er satt
 */
export const isDebug = () => {
    return !!window?.HN?.Debug;
};
